<template>
    <div>        
        <svg style="margin: auto;display: block;" width="100px" height="30px" viewBox="0 35 100 25" preserveAspectRatio="xMidYMid">
            <g transform="translate(12.5 50)">
            <circle cx="0" cy="0" r="6" fill="#1d3f72" transform="scale(0.426535 0.426535)">
            <animateTransform attributeName="transform" type="scale" begin="-0.42857142857142855s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(25 50)">
            <circle cx="0" cy="0" r="6" fill="#5699d2" transform="scale(0.233351 0.233351)">
            <animateTransform attributeName="transform" type="scale" begin="-0.35714285714285715s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(37.5 50)">
            <circle cx="0" cy="0" r="6" fill="#d8ebf9" transform="scale(0.0786276 0.0786276)">
            <animateTransform attributeName="transform" type="scale" begin="-0.2857142857142857s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(50 50)">
            <circle cx="0" cy="0" r="6" fill="#71c2cc" transform="scale(0.00141899 0.00141899)">
            <animateTransform attributeName="transform" type="scale" begin="-0.21428571428571427s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(62.5 50)">
            <circle cx="0" cy="0" r="6" fill="#1d3f72" transform="scale(0.0472674 0.0472674)">
            <animateTransform attributeName="transform" type="scale" begin="-0.14285714285714285s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(75 50)">
            <circle cx="0" cy="0" r="6" fill="#5699d2" transform="scale(0.185077 0.185077)">
            <animateTransform attributeName="transform" type="scale" begin="-0.07142857142857142s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g><g transform="translate(87.5 50)">
            <circle cx="0" cy="0" r="6" fill="#d8ebf9" transform="scale(0.370717 0.370717)">
            <animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
            </circle>
            </g>
        </svg>
    </div>
</template>
<script>
export default{
    name: 'notification',   
}
</script>